import { reportHeaderImg1, reportHeaderImg2 } from "./reportAssets";

/**
 * Documento imprimible: "FORMATO DE RECURSO DE REPOSICIÓN"
 * (Decisión de exclusión del PNIS).
 *
 * Reproduce el formato oficial de 1 página. Los campos "Yo, ... identificado(a) con
 * cédula de ciudadanía No. ..." y "C.C. No." se auto-diligencian con los datos que
 * devuelve reportServices.headlineReport(cubId); el resto de campos quedan en blanco
 * para ser diligenciados a mano, igual que en el documento físico.
 *
 * Se renderiza oculto y se imprime vía print-js (mismo patrón que
 * ConsolidatedPurchaseReport / BalanceInFavorReport / RenegotiationConsentReport).
 */
export const RepositionResourceReport = ({ dataReport }) => {
    const line = { borderBottom: "1px solid #000", display: "inline-block", minWidth: "60px" };
    const fill = (value, minWidth = "200px") => (
        <span style={{ ...line, minWidth }}>&nbsp;{value ?? ""}&nbsp;</span>
    );

    const sectionTitle = { fontWeight: "bold", marginTop: "12px", marginBottom: "6px" };
    const paragraph = { textAlign: "justify", margin: "6px 0", lineHeight: 1.4 };
    const field = { margin: "8px 0" };

    // Pie de página repetido en cada hoja impresa (vía <tfoot>, que el navegador
    // reimprime al final de cada página).
    const pageFooter = (
        <div style={{ textAlign: "center", marginTop: "40px", paddingTop: "12px", borderTop: "1px solid #000", fontSize: "12px" }}>
            Dirección de Sustitución de Cultivos de Uso Ilícito — Carrera 7 No. 26-20, Bogotá D. C.,
            Colombia. Edificio Tequendama (Pisos 29, 32 y 33) — Teléfono: 4221030, Ext 7002
            <br />
            Formato propuesto — Página 1 de 1
        </div>
    );

    return (
        <table id="reposition-resource-section" style={{ fontSize: "13px", width: "100%", borderCollapse: "collapse" }}>
            <tfoot>
                <tr>
                    <td>{pageFooter}</td>
                </tr>
            </tfoot>
            <tbody>
            <tr>
            <td>
            {/* Encabezado institucional */}
            <div style={{ textAlign: "center", marginBottom: "10px" }}>
                <img src={reportHeaderImg1} alt="Agencia de Renovación del Territorio" style={{ height: "60px", margin: "0 15px" }} />
                <img src={reportHeaderImg2} alt="Dirección de Sustitución de Cultivos de Uso Ilícito" style={{ height: "60px", margin: "0 15px" }} />
            </div>

            <div style={{ textAlign: "center", fontWeight: "bold", margin: "14px 0" }}>
                FORMATO DE RECURSO DE REPOSICIÓN
                <br />
                <span style={{ fontWeight: "normal", fontStyle: "italic", fontSize: "12px" }}>
                    Decisión de exclusión del Programa Nacional Integral de Sustitución de Cultivos de Uso Ilícito – PNIS
                </span>
            </div>

            {/* Instrucción */}
            <p style={{ ...paragraph, fontStyle: "italic", textAlign: "center" }}>
                Instrucción: diligencie los espacios, explique de manera concreta por qué no asistió a las ferias y/o no
                culminó la renegociación. Adjunte los soportes disponibles. Si requiere más espacio, anexe una hoja.
            </p>

            <div style={field}>Ciudad y fecha: {fill("", "400px")}</div>

            <div style={{ ...field, marginTop: "16px" }}>
                Señores
                <br />
                <strong>AGENCIA DE RENOVACIÓN DEL TERRITORIO – ART</strong>
                <br />
                Dirección de Sustitución de Cultivos de Uso Ilícito – DSCI
            </div>

            <p style={paragraph}>
                Asunto: Recurso de reposición contra la decisión contenida en la Resolución No. {fill("", "250px")} de
                fecha {fill("", "250px")}.
            </p>

            <p style={paragraph}>
                Yo, {fill(dataReport?.nombre, "400px")}, identificado(a) con cédula de ciudadanía No.{" "}
                {fill(dataReport?.cedula, "200px")}, en oportunidad legal, interpongo recurso de reposición contra la
                decisión que dispuso mi exclusión del PNIS por falta de: (i) renegociación o (ii) asistencia a las ferias
                encaminadas a la culminación del Plan de Inversión.
            </p>

            {/* Solicitud */}
            <div style={sectionTitle}>SOLICITUD</div>
            <p style={paragraph}>
                Solicito que se revoque la decisión de exclusión y se me permita continuar la ruta de atención, actualizar
                mis datos, culminar la renegociación y participar en la próxima jornada, feria o mecanismo de
                implementación que programe la DSCI.
            </p>

            {/* Justificación */}
            <div style={sectionTitle}>JUSTIFICACIÓN</div>
            <p style={paragraph}>
                Explique las circunstancias que le impidieron asistir o culminar el trámite (por ejemplo: problemas de
                salud, transporte):
            </p>
            <div style={{ margin: "10px 0" }}>{fill("", "100%")}</div>
            <div style={{ margin: "10px 0" }}>{fill("", "100%")}</div>
            <div style={{ margin: "10px 0" }}>{fill("", "100%")}</div>
            <div style={{ margin: "10px 0" }}>{fill("", "100%")}</div>
            <div style={{ margin: "10px 0" }}>{fill("", "100%")}</div>

            <p style={paragraph}>
                Manifiesto expresamente mi voluntad de continuar en el PNIS y de atender las convocatorias y requerimientos
                que me sean comunicados.
            </p>

            <div style={field}>
                Teléfono: {fill("", "220px")}&nbsp;&nbsp;&nbsp;&nbsp;Correo electrónico: {fill("", "220px")}
            </div>
            <div style={field}>
                Vereda/Municipio: {fill("", "220px")}&nbsp;&nbsp;&nbsp;&nbsp;Anexos o soportes: {fill("", "220px")}
            </div>

            <div style={{ ...field, marginTop: "24px" }}>
                Firma: {fill("", "280px")}&nbsp;&nbsp;&nbsp;&nbsp;C.C. No. {fill(dataReport?.cedula, "200px")}
            </div>

            <p style={{ ...paragraph, marginTop: "20px", fontSize: "12px" }}>
                Fundamento: artículos 74, 76 y 77 de la Ley 1437 de 2011; Resolución 0021 de 2024 y las normas que la
                modifiquen o adicionen. Este formato es orientador y su uso no es obligatorio; el recurso puede presentarse
                en escrito libre.
            </p>
            </td>
            </tr>
            </tbody>
        </table>
    );
};